import { Box, Collapse, Grid, Skeleton } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { SchematisationWithId } from "@/queries/query-hcc-schematisation";

import { SCHEMATISATION_CARD_HEIGHT, SchematisationCard } from "./components/schematisation-card";
import { useSchematisationList } from "./hooks/use-schematisation-list";

type SchematisationListProps = {
  isSectionExpanded?: boolean;
  schematisations: SchematisationWithId[];
  isSchematisationsLoading: boolean;
  setSchematisation: (schematisation: SchematisationWithId | undefined) => void;
};

export const SchematisationList = ({
  isSectionExpanded,
  schematisations,
  isSchematisationsLoading,
  setSchematisation,
}: SchematisationListProps) => {
  const { itemsInFirstRow, displaySchematisationsAmount, listEndRef } = useSchematisationList({
    isSectionExpanded,
    schematisations,
  });

  const noSchematisations = !isSchematisationsLoading && schematisations.length === 0;

  return (
    <>
      <Grid templateColumns={`repeat(${itemsInFirstRow}, 1fr)`} gap={4}>
        {isSchematisationsLoading &&
          Array.from({ length: displaySchematisationsAmount }).map((_, index) => (
            <Skeleton key={index} h={SCHEMATISATION_CARD_HEIGHT} />
          ))}

        {noSchematisations && (
          <Box gridColumn="1 / -1" textAlign="center">
            <FormattedMessage
              id="text.no_model_schematisations"
              defaultMessage="There are no model schematisations with these filters"
            />
          </Box>
        )}

        {schematisations.map((schematisation, idx) => (
          <Collapse in={idx < displaySchematisationsAmount} unmountOnExit key={schematisation.id}>
            <SchematisationCard
              setSchematisation={setSchematisation}
              schematisation={schematisation}
            />
          </Collapse>
        ))}
      </Grid>

      <Box ref={listEndRef} aria-hidden h={1} />
    </>
  );
};
